/** Tự sinh bởi scripts/gom-bai-agent.mjs lúc build, không sửa tay. */
export default [
  {
    "status": "PUBLISHED",
    "slug": "nhin-lai-thang-10-2026",
    "title": "Nhìn lại tháng 10/2026: vốn dồn về AI, TP.HCM miễn thuế startup, tiền nhà nước còn tiêu chậm",
    "excerpt": "Tháng 10/2026 có ba điều founder Việt nên ghi nhớ: vốn toàn cầu dồn mạnh vào AI và vài vòng khổng lồ, TP.HCM có ưu đãi thuế riêng cho startup từ năm 2027, và tiền nhà nước cho đổi mới sáng tạo vẫn tiêu chậm. Bài tóm lại số liệu đã kiểm và việc nên làm trước cuối năm.",
    "category": "Nhìn lại tháng",
    "stages": [
      "Idea",
      "Pre-seed",
      "Seed",
      "Series A"
    ],
    "storyType": "huong-dan",
    "author": "Fundraising Vietnam",
    "publishedAt": "2026-10-30",
    "seoTitle": "Nhìn lại tháng 10/2026: gọi vốn, chính sách cho startup Việt",
    "seoDescription": "Tổng kết tháng 10/2026 cho founder Việt: vốn AI toàn cầu, IPO Anthropic, Dat Bike trả khoản vay chuyển đổi, miễn thuế startup TP.HCM, giải ngân vốn KHCN.",
    "relatedTools": [
      {
        "slug": "safe-va-trai-phieu-chuyen-doi",
        "label": "SAFE và trái phiếu chuyển đổi"
      },
      {
        "slug": "goi-bao-nhieu",
        "label": "Tính số tiền cần gọi"
      },
      {
        "slug": "tinh-runway",
        "label": "Tính runway khi có khoản phải hoàn trả"
      },
      {
        "slug": "quy-phu-hop",
        "label": "Tìm quỹ phù hợp"
      }
    ],
    "templates": [
      "du-toan-nhiem-vu-tai-tro-natif"
    ],
    "sources": [
      {
        "label": "Crunchbase News: số liệu vốn mạo hiểm toàn cầu quý 3/2026 (05/10/2026)",
        "url": "https://news.crunchbase.com/venture/q3-2026-global-startup-funding-ai-billion-dollar-rounds-exits-data/"
      },
      {
        "label": "Artiverse: tổng hợp số liệu Crunchbase quý 3/2026 (05/10/2026)",
        "url": "https://www.artiverse.ca/ai-funding-surges-as-billion-dollar-startup-rounds-hit-new-high/"
      },
      {
        "label": "The Next Web: Anthropic nộp hồ sơ IPO trên Nasdaq (26/10/2026)",
        "url": "https://thenextweb.com/news/anthropic-ipo-filing-nasdaq-ant-s-1"
      },
      {
        "label": "Yahoo Finance: Anthropic công khai bản cáo bạch IPO (26/10/2026)",
        "url": "https://finance.yahoo.com/technology/article/anthropic-publicly-files-ipo-prospectus-noting-strong-revenue-growth-and-massive-spending-131807138.html"
      },
      {
        "label": "VIR: PIDG thoái vốn khỏi Dat Bike sau vòng Series B 26 triệu USD (20/10/2026)",
        "url": "https://vir.com.vn/pidg-exits-dat-bike-following-successful-scale-up-and-a-26-million-series-b-fundraise-163294.html"
      },
      {
        "label": "TNGlobal: PIDG thoái vốn khỏi Dat Bike (21/10/2026)",
        "url": "https://technode.global/?p=995740"
      },
      {
        "label": "Tạp chí Kinh tế Tài chính: TP.HCM nhiều chính sách ưu đãi thuế cho khởi nghiệp đổi mới sáng tạo (08/10/2026)",
        "url": "https://tapchikinhtetaichinh.vn/tp-ho-chi-minh-nhieu-chinh-sach-uu-dai-thue-cho-khoi-nghiep-doi-moi-sang-tao-168925.html"
      },
      {
        "label": "Thuế Mân: miễn thuế 5 năm cho hoạt động khởi nghiệp sáng tạo TP.HCM (23/10/2026)",
        "url": "https://thue.man.net.vn/mien-thue-5-nam-cho-hoat-dong-khoi-nghiep-sang-tao-tp-hcm/"
      },
      {
        "label": "VietnamPlus: giải ngân kinh phí KHCN, ĐMST và chuyển đổi số đạt 41,18% (27/10/2026)",
        "url": "https://www.vietnamplus.vn/giai-ngan-kinh-phi-khoa-hoc-cong-nghe-doi-moi-sang-tao-va-chuyen-doi-so-dat-4118-post1144595.vnp"
      },
      {
        "label": "Đại Đoàn Kết: giải ngân kinh phí KHCN và chuyển đổi số mới đạt 41,18% (27/10/2026)",
        "url": "https://daidoanket.vn/giai-ngan-kinh-phi-khoa-hoc-cong-nghe-va-chuyen-doi-so-moi-dat-41-18.html"
      },
      {
        "label": "Đại biểu Nhân dân: thảo luận tổ dự án Luật Phát triển doanh nghiệp nhỏ và vừa (17/10/2026)",
        "url": "https://daibieunhandan.vn/chinh-sach-khong-chi-dung-ma-con-phai-kha-thi-10434397.html"
      },
      {
        "label": "Mekong ASEAN: Quốc hội bàn Luật Phát triển doanh nghiệp nhỏ và vừa (29/10/2026)",
        "url": "https://mekongasean.vn/quoc-hoi-ban-luat-phat-trien-doanh-nghiep-nho-va-vua-61216.html"
      }
    ],
    "sections": [
      {
        "heading": "Tháng 10 trong ba ý",
        "paragraphs": [
          "Số liệu trong bài chốt ngày 30/10/2026. Mỗi con số đều khớp ở ít nhất hai nguồn có ngày đăng; chỗ nào các nguồn lệch nhau, bài chỉ mô tả bằng lời.",
          "Nếu chỉ có một phút, hãy nhớ ba ý. Một: vốn mạo hiểm thế giới đang dồn rất mạnh vào AI và vào vài vòng khổng lồ, nên đừng lấy các vòng đó làm thước đo cho mình. Hai: TP.HCM đã có ưu đãi thuế riêng cho startup khởi nghiệp sáng tạo, áp dụng từ năm 2027, và muốn hưởng thì phải chuẩn bị giấy tờ từ bây giờ. Ba: tiền nhà nước cho khoa học công nghệ và đổi mới sáng tạo còn nhiều nhưng tiêu chậm, hai tháng cuối năm là lúc nên nộp hồ sơ.",
          "Bài này gom các tin của cả tháng. Muốn xem chi tiết từng tuần, đọc thêm [[/playbook/nhin-lai-tuan-43-2026|bài nhìn lại tuần 43]]."
        ]
      },
      {
        "heading": "Vốn toàn cầu: AI chiếm gần hai phần ba",
        "paragraphs": [
          "Đầu tháng 10, Crunchbase công bố số liệu quý 3/2026 (tháng 7 đến tháng 9). Tổng vốn mạo hiểm toàn cầu đạt 159 tỷ USD. Riêng các startup AI nhận 102 tỷ USD, tức 64%. Có 27 công ty gọi được vòng từ 1 tỷ USD trở lên, mức cao kỷ lục.",
          "Đọc con số này thế nào? Phần lớn tiền chảy vào một nhóm nhỏ công ty AI ở Mỹ. Các bản tin trong tháng cũng liên tục có vòng seed hàng chục triệu USD cho đội ngũ AI và robot chưa có doanh thu. Đó là ngoại lệ, không phải mặt bằng.",
          "Với founder Việt ở vòng pre-seed hay seed, thước đo đúng là các thương vụ cùng giai đoạn ở Đông Nam Á. Hãy tính số tiền cần gọi từ kế hoạch 18 đến 24 tháng của chính mình, bằng [[/cong-cu/goi-bao-nhieu|công cụ tính số tiền gọi vốn]], thay vì nhìn tiêu đề báo."
        ]
      },
      {
        "heading": "IPO của Anthropic: bài học về chỉ số, không phải về quy mô",
        "paragraphs": [
          "Ngày 26/10/2026, Anthropic công khai hồ sơ xin niêm yết trên Nasdaq với mã ANT. Theo hồ sơ, doanh thu nửa đầu năm 2026 đạt 16,3 tỷ USD. Các bài báo cũng chỉ ra một phần đáng kể doanh thu đến từ vài khách hàng lớn, dù mỗi nguồn trích một cách tính khác nhau.",
          "Startup Việt không cần so quy mô. Điều đáng học là cách thị trường soi số liệu: tăng trưởng, mức phụ thuộc vào vài khách hàng, và tiền đến từ kênh nào. Quỹ Series A sẽ hỏi đúng những câu đó, chỉ ở quy mô nhỏ hơn.",
          "Ví dụ giả định: bạn có doanh thu 6 tỷ đồng một năm, trong đó một khách hàng chiếm 3 tỷ đồng. Hãy tự ghi rõ tỷ lệ 50% này trong deck và nói kế hoạch giảm phụ thuộc. Để quỹ tự phát hiện trong thẩm định thì mất điểm nhiều hơn. Chỉ số nên theo dõi thêm là [[/thuat-ngu/nrr-net-revenue-retention|NRR]]."
        ]
      },
      {
        "heading": "Việt Nam: khoản vay chuyển đổi của Dat Bike được hoàn trả",
        "paragraphs": [
          "Tin gọi vốn đáng chú ý nhất của startup Việt trong tháng là một cuộc thoái vốn. Ngày 20 và 21/10/2026, VIR và TNGlobal đưa tin PIDG, qua đơn vị InfraCo, đã rút khỏi Dat Bike sau khi startup xe máy điện này hoàn trả khoản vay chuyển đổi 4 triệu USD cấp năm 2024. Vòng Series B của Dat Bike đạt tổng 26 triệu USD sau lần đóng thứ hai vào tháng 3/2026, do F.C.C. (Nhật) và Rebright Partners đồng dẫn dắt.",
          "Bài học: khoản vay chuyển đổi không phải lúc nào cũng thành cổ phần. Nó có thể được trả lại, và lúc đó công ty cần tiền mặt. Trước khi ký, hãy đọc kỹ ngày đáo hạn, lãi suất, mức chiết khấu, trần định giá và điều gì xảy ra nếu không có vòng gọi vốn kế tiếp."
        ],
        "bullets": [
          "Đọc nhanh khái niệm: [[/thuat-ngu/trai-phieu-chuyen-doi|trái phiếu, khoản vay chuyển đổi]].",
          "Thử các kịch bản chuyển đổi bằng [[/cong-cu/safe-va-trai-phieu-chuyen-doi|công cụ SAFE và trái phiếu chuyển đổi]].",
          "Đưa kịch bản hoàn trả vào mô hình dòng tiền, kiểm lại bằng [[/cong-cu/tinh-runway|công cụ tính runway]]."
        ]
      },
      {
        "heading": "Chính sách: TP.HCM miễn thuế cho startup từ năm 2027",
        "paragraphs": [
          "Nghị quyết 59/2026/NQ-HĐND được HĐND TP.HCM thông qua ngày 22/09/2026 và được báo chí phân tích nhiều trong tháng 10. Theo các bài tổng hợp, thu nhập từ hoạt động khởi nghiệp sáng tạo được miễn thuế thu nhập doanh nghiệp 5 năm, tính từ khi phát sinh thuế phải nộp. Tiền lương, tiền công của người làm việc tại các tổ chức thuộc diện ưu đãi được miễn thuế thu nhập cá nhân 5 năm liên tục. Chính sách áp dụng từ kỳ tính thuế năm 2027.",
          "Điều kiện chung: trụ sở chính đặt tại TP.HCM, và doanh nghiệp khởi nghiệp sáng tạo phải có giấy công nhận còn hiệu lực. Các tiêu chí chi tiết nằm trong toàn văn nghị quyết, nên đọc bản gốc trước khi đăng ký.",
          "Ví dụ giả định: startup có lợi nhuận chịu thuế 1 tỷ đồng năm 2027. Với thuế suất giả định 20%, khoản được miễn là 200 triệu đồng, đủ trả lương thêm một kỹ sư vài tháng. Thuế suất thực tế của bạn có thể khác, hãy hỏi kế toán."
        ],
        "bullets": [
          "Kiểm tra trụ sở chính đang đăng ký ở đâu.",
          "Xem công ty đã có giấy công nhận doanh nghiệp khởi nghiệp sáng tạo chưa, nếu chưa thì hỏi thủ tục ngay trong quý 4.",
          "Ghi ưu đãi này vào mô hình tài chính 2027 dưới dạng kịch bản, không coi là chắc chắn cho tới khi có giấy công nhận.",
          "Các bài khác cùng chủ đề: [[/playbook/chu-de/chinh-sach-uu-dai|Chính sách và ưu đãi]]."
        ]
      },
      {
        "heading": "Tiền nhà nước còn nhiều nhưng tiêu chậm",
        "paragraphs": [
          "Theo số liệu Bộ Khoa học và Công nghệ được VietnamPlus và Đại Đoàn Kết đưa ngày 27/10/2026, tính đến 26/10/2026 cả nước mới giải ngân 41,18% kinh phí cho khoa học công nghệ, đổi mới sáng tạo và chuyển đổi số, tức khoảng 21.693 tỷ trên 52.680 tỷ đồng dự toán. Riêng mảng đổi mới sáng tạo ở địa phương chỉ đạt 27,54%.",
          "Nghĩa là gì với founder? Nguồn vốn không pha loãng vẫn còn, và các đơn vị đang chịu áp lực tiêu đúng hạn. Nhưng tiền nhà nước đi kèm hồ sơ chặt và yêu cầu kết quả đo được. Nếu bạn làm AI, chuyển đổi số hay công nghệ cho sản xuất, đây là lúc chuẩn bị đề xuất có chỉ số đầu ra rõ ràng.",
          "Bắt đầu từ bài [[/playbook/tai-tro-ung-dung-ai-natif-2026|tài trợ ứng dụng AI của NATIF]] và mẫu [[/mau/du-toan-nhiem-vu-tai-tro-natif|dự toán nhiệm vụ tài trợ NATIF]]."
        ]
      },
      {
        "heading": "Luật Doanh nghiệp nhỏ và vừa mới: theo dõi, chưa áp dụng",
        "paragraphs": [
          "Trong tháng 10, Quốc hội đã thảo luận dự thảo Luật Phát triển doanh nghiệp nhỏ và vừa, thay luật hỗ trợ hiện hành. Hai điểm liên quan tới startup: kết nối doanh nghiệp khởi nghiệp sáng tạo với chuyên gia, vườn ươm, trung tâm đổi mới sáng tạo và nhà đầu tư; và hướng cho vay dựa trên dòng tiền, dữ liệu, khả năng tạo doanh thu thay vì chỉ dựa vào tài sản thế chấp.",
          "Luật chưa được thông qua, nên chưa có gì để áp dụng. Việc làm được ngay là chuẩn hóa báo cáo tài chính và dòng tiền. Đó là hồ sơ mà cả ngân hàng lẫn quỹ đều sẽ cần. Xem lại [[/playbook/ba-bao-cao-tai-chinh-cua-startup|ba báo cáo tài chính của startup]]."
        ]
      },
      {
        "heading": "Việc cần làm ngay",
        "paragraphs": [
          "Năm việc nên xong trước 31/12/2026:"
        ],
        "bullets": [
          "Tính lại số tiền cần gọi cho 18 đến 24 tháng bằng [[/cong-cu/goi-bao-nhieu|công cụ gọi bao nhiêu]], so với thương vụ Đông Nam Á cùng giai đoạn.",
          "Lập bảng tỷ trọng doanh thu theo khách hàng; nếu một khách hàng chiếm quá nửa, viết sẵn kế hoạch giảm phụ thuộc.",
          "Nếu đang có khoản vay chuyển đổi hoặc SAFE, ghi ngày đáo hạn và kịch bản hoàn trả vào mô hình dòng tiền.",
          "Startup ở TP.HCM: kiểm tra điều kiện của Nghị quyết 59/2026/NQ-HĐND và hồ sơ công nhận khởi nghiệp sáng tạo.",
          "Startup làm AI, chuyển đổi số: chuẩn bị đề xuất tài trợ có chỉ số đầu ra, dùng [[/cong-cu/quy-phu-hop|công cụ tìm quỹ phù hợp]] để lọc thêm nguồn vốn."
        ]
      }
    ],
    "coverImage": "https://fundraising.vn/anh/playbook/nhin-lai-thang-10-2026.webp",
    "ogImage": "https://fundraising.vn/anh/playbook/nhin-lai-thang-10-2026-og.jpg",
    "coverAlt": "Thẻ tóm tắt tháng 10/2026: vốn mạo hiểm toàn cầu quý 3 đạt 159 tỷ USD với AI chiếm 64%, Anthropic nộp hồ sơ IPO, Dat Bike hoàn trả khoản vay chuyển đổi 4 triệu USD, TP.HCM miễn thuế startup từ 2027, giải ngân vốn khoa học công nghệ đạt 41,18%",
    "coverCaption": "Năm con số đáng nhớ của tháng 10/2026 với founder Việt."
  },
  {
    "status": "PUBLISHED",
    "slug": "toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai",
    "title": "Toán học của quỹ VC: vì sao quỹ từ chối cả startup đang có lãi",
    "excerpt": "Một quỹ 100 triệu USD phải trả về khoảng 310 triệu USD sau 10 năm, và phép tính đó chỉ thành khi có ít nhất một công ty thoát vốn cỡ 1 tỷ USD. Bài này đi từng bước qua phép tính, dữ liệu thật về cách lợi nhuận dồn vào số ít công ty, và năm câu hỏi nhà đầu tư dùng để chấm hồ sơ của bạn.",
    "category": "Góc nhìn quỹ",
    "stages": [
      "Idea",
      "Pre-seed",
      "Seed"
    ],
    "storyType": "huong-dan",
    "author": "Fundraising Vietnam",
    "publishedAt": "2026-11-01",
    "seoTitle": "Toán học của quỹ VC: vì sao quỹ cần công ty trả lại cả quỹ, và 5T nhà đầu tư dùng để chấm startup",
    "seoDescription": "Quỹ VC 100 triệu USD phải trả về 310 triệu USD sau 10 năm. Năm kịch bản danh mục, dữ liệu Correlation Ventures và Horsley Bridge, bối cảnh Việt Nam 2025, công thức tự tính mốc trả lại cả quỹ và 5T: Team, TAM, Technology, Traction, Trenches.",
    "relatedTools": [
      {
        "slug": "diem-san-sang-goi-von",
        "label": "Chấm điểm sẵn sàng gọi vốn theo 5T"
      },
      {
        "slug": "pitch-deck-10-slide",
        "label": "Kiểm tra pitch deck có trả lời đủ 5T chưa"
      },
      {
        "slug": "quy-mo-thi-truong",
        "label": "Tính TAM, SAM, SOM từ dưới lên"
      },
      {
        "slug": "quy-phu-hop",
        "label": "Tìm quỹ có quy mô và vòng phù hợp"
      }
    ],
    "sections": [
      {
        "heading": "Câu hỏi thật sự của quỹ",
        "paragraphs": [
          "Nhiều founder bị từ chối dù công ty đang có doanh thu, có lãi, tăng trưởng đều. Lý do thường không nằm ở công ty, mà ở phép tính của chính quỹ đầu tư.",
          "Quỹ VC không hỏi \"công ty này có tốt không\". Quỹ hỏi \"công ty này có thể trả lại cả quỹ không\". Hiểu được phép tính phía sau câu hỏi đó, bạn sẽ biết hồ sơ gọi vốn cần chứng minh điều gì, và lúc nào VC không phải nguồn vốn hợp với mình.",
          "Bài viết dựa trên bài giảng Understanding how VCs think của Guhesh Ramanathan, bổ sung dữ liệu thật về lợi nhuận của quỹ và bối cảnh Việt Nam năm 2025."
        ]
      },
      {
        "heading": "Tiền của quỹ đến từ người khác",
        "paragraphs": [
          "Một quỹ đầu tư mạo hiểm có hai bên. Người góp vốn ([[lp-va-gp|LP]]) đưa tiền và chờ lợi nhuận. Người quản lý quỹ (GP) chọn startup để rót tiền. GP sống bằng [[phi-quan-ly-quy|phí quản lý]], và chỉ được chia lợi nhuận ([[carry]]) khi quỹ vượt mức lãi đã hứa với LP."
        ],
        "table": {
          "caption": "Ai làm gì trong một quỹ VC",
          "headers": [
            "Vai trò",
            "Là ai",
            "Kiếm tiền từ đâu"
          ],
          "rows": [
            [
              "Người góp vốn (LP)",
              "Quỹ hưu trí, gia đình giàu có, tổ chức lớn. Thường chỉ dành 2 đến 5% tài sản cho VC vì đây là kênh rủi ro nhất",
              "Lợi nhuận quỹ trả về"
            ],
            [
              "Người quản lý quỹ (GP)",
              "Đội ngũ chọn và hỗ trợ startup",
              "Phí quản lý khoảng 2% mỗi năm, và khoảng 20% lợi nhuận (carry) khi vượt mức lãi hứa với LP"
            ],
            [
              "Startup",
              "Các công ty trong danh mục",
              "Nhận vốn, đổi lại một phần cổ phần"
            ]
          ]
        },
        "notes": [
          "Quy ước 2 và 20: quỹ 100 triệu USD, kỳ hạn 10 năm, dùng tối đa khoảng 2 triệu USD mỗi năm cho vận hành, tổng khoảng 20 triệu USD. Chỉ khoảng 80 triệu USD thực sự được đem đi đầu tư."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/dong-tien-cua-quy.webp",
          "alt": "Sơ đồ dòng tiền: người góp vốn đưa tiền vào quỹ và đòi lãi khoảng 12% mỗi năm, quỹ giữ khoảng 2% mỗi năm làm phí quản lý rồi rót vốn vào startup; khi thoát vốn tiền quay về, trả LP trước, phần lợi nhuận vượt mức lãi mới chia khoảng 20% cho GP",
          "caption": "",
          "width": 1600,
          "height": 542,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/dong-tien-cua-quy-hep.webp"
        }
      },
      {
        "heading": "Con số 3,1 lần",
        "paragraphs": [
          "Mức lãi LP thường kỳ vọng ở kênh VC khoảng 12% mỗi năm. Cộng dồn 10 năm, 1,12 mũ 10 bằng khoảng 3,1. Quỹ 100 triệu USD vì vậy phải trả về khoảng 310 triệu USD.",
          "Điểm khó nằm ở chỗ quỹ chỉ có 80 triệu USD để đầu tư. Số tiền đó phải thành 310 triệu USD, tức mỗi đồng đầu tư phải sinh lời gần 3,9 lần. Đây mới là mức tối thiểu để LP hài lòng. GP muốn có phần chia lợi nhuận thì quỹ phải vượt con số này."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/quy-phai-tra-ve-3-1-lan.webp",
          "alt": "Biểu đồ cột số tiền quỹ phải trả về theo năm, từ 100 triệu USD năm 0 lên khoảng 310 triệu năm 10; bên cạnh là thanh quỹ 100 triệu chia 20 phí và 80 đem đi đầu tư, cần gấp gần 3,9 lần",
          "caption": "",
          "width": 1600,
          "height": 816,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/quy-phai-tra-ve-3-1-lan-hep.webp"
        }
      },
      {
        "heading": "Năm kịch bản cho một quỹ 100 triệu USD",
        "paragraphs": [
          "Giả định: quỹ rót 8 triệu USD vào mỗi công ty, tổng 10 công ty, qua các vòng seed, Series A, Series B, và còn nắm 25% cổ phần mỗi công ty lúc thoát vốn. Thoát vốn là khi công ty được bán lại hoặc lên sàn; quỹ nhận về 25% số tiền đó."
        ],
        "table": {
          "caption": "Tiền quỹ nhận về so với mục tiêu 310 triệu USD",
          "headers": [
            "Kịch bản",
            "Giá thoát vốn của 10 công ty",
            "Quỹ nhận về",
            "Đạt 310 triệu USD?"
          ],
          "rows": [
            [
              "Cả 10 công ty đều ổn",
              "10 công ty, mỗi công ty 50 triệu USD",
              "125 triệu USD",
              "Chưa"
            ],
            [
              "Một nửa tốt hơn",
              "5 công ty 50 triệu USD, 5 công ty 100 triệu USD",
              "187,5 triệu USD",
              "Chưa"
            ],
            [
              "Thêm một công ty lớn",
              "5 công ty 50 triệu, 4 công ty 100 triệu, 1 công ty 500 triệu USD",
              "287,5 triệu USD",
              "Chưa"
            ],
            [
              "Có một kỳ lân",
              "9 công ty 50 triệu USD, 1 công ty 1 tỷ USD",
              "362,5 triệu USD",
              "Đạt"
            ],
            [
              "Thực tế hay gặp",
              "5 công ty đóng cửa, 3 công ty 25 triệu, 1 công ty 200 triệu, 1 công ty 1 tỷ USD",
              "318,75 triệu USD",
              "Đạt"
            ]
          ]
        },
        "notes": [
          "Ba kịch bản đầu không có công ty nào thất bại mà vẫn trượt mục tiêu, chỉ vì thiếu một thương vụ thật lớn. Kịch bản thực tế có năm công ty mất trắng nhưng vẫn đạt, vì một công ty thoát vốn 1 tỷ USD mang về 250 triệu USD, khoảng 78% tổng số tiền quỹ nhận về.",
          "Tỷ lệ 25% là giả định lạc quan. Qua nhiều vòng, cổ phần của quỹ thường bị pha loãng, nên giá thoát vốn cần có trên thực tế còn cao hơn."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/nam-kich-ban-danh-muc.webp",
          "alt": "Biểu đồ thanh ngang năm kịch bản so với vạch 310 triệu USD: 125, 187,5 và 287,5 đều trượt; có kỳ lân 362,5 và thực tế một nửa đóng cửa 318,75 đều đạt",
          "caption": "",
          "width": 1600,
          "height": 903,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/nam-kich-ban-danh-muc-hep.webp"
        }
      },
      {
        "heading": "Dữ liệu thật còn lệch hơn quy tắc 80/20",
        "paragraphs": [
          "Bài giảng gốc dùng quy tắc 80/20: 80% lợi nhuận đến từ 20% công ty. Dữ liệu nhiều năm tại Mỹ cho thấy mức tập trung còn cao hơn. Giới đầu tư gọi đây là [[luat-luy-thua|luật lũy thừa]]: một khoản đầu tư lỗ tối đa 1 lần vốn, nhưng có thể lãi 50 đến 100 lần."
        ],
        "table": {
          "caption": "Lợi nhuận VC dồn vào số rất ít công ty",
          "headers": [
            "Nguồn dữ liệu",
            "Phát hiện"
          ],
          "rows": [
            [
              "Correlation Ventures, hơn 21.000 vòng gọi vốn tại Mỹ, 2004 đến 2013",
              "Gần 2/3 số vòng không thu hồi đủ vốn; chỉ khoảng 4% lãi trên 10 lần"
            ],
            [
              "Correlation Ventures, 7.976 thương vụ đã thoát vốn, 2003 đến 2012",
              "39% phá sản, 29% bán dưới giá vốn, chỉ 32% có lãi"
            ],
            [
              "Horsley Bridge, số liệu trong sách The Power Law của Sebastian Mallaby",
              "Khoảng 6% khoản đầu tư tạo ra khoảng 60% tổng lợi nhuận; nhiều quỹ có một công ty trả lại cả quỹ"
            ]
          ]
        },
        "notes": [
          "Hệ quả cho founder: VC có thể từ chối một doanh nghiệp có lãi, tăng trưởng đều, nhưng giới hạn ở vài chục triệu USD. Công ty đó tốt, chỉ là không thể trở thành công ty gánh cả quỹ. Bài Vì sao nhà đầu tư thiên thần đòi lợi nhuận 30 lần trong Playbook giải thích cùng logic này ở cấp nhà đầu tư cá nhân."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/loi-nhuan-don-vao-so-it.webp",
          "alt": "Hai biểu đồ: 7.976 thương vụ đã thoát vốn gồm 39% phá sản, 29% bán dưới giá vốn, 32% có lãi; theo Horsley Bridge 6% số khoản đầu tư tạo ra 60% tổng lợi nhuận",
          "caption": "",
          "width": 1600,
          "height": 653,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/loi-nhuan-don-vao-so-it-hep.webp"
        }
      },
      {
        "heading": "Ở Việt Nam: tiền ít hơn, chọn lọc hơn",
        "paragraphs": [
          "Năm 2025, vốn VC vào Việt Nam dồn mạnh vào số ít công ty đã chứng minh mô hình. Theo báo cáo của VinVentures, cả năm có khoảng 215 triệu USD qua 41 thương vụ công bố, giảm khoảng 30% so với năm trước, và 10 thương vụ lớn nhất chiếm 72% tổng giá trị.",
          "Báo cáo của NIC, VPCA và Do Ventures đưa ra con số cao hơn, khoảng 509 triệu USD, tăng 28%, vì cách đếm rộng hơn so với chỉ tính thương vụ công bố công khai. Hai báo cáo cùng cho thấy nhà đầu tư thận trọng hơn với mô hình chưa kiểm chứng, và thương vụ dưới 1 triệu USD ngày càng ít.",
          "Quỹ trong nước nhỏ hơn quỹ Mỹ nên mốc trả lại cả quỹ cũng thấp hơn. Nhưng kênh thoát vốn qua mua bán sáp nhập và niêm yết cũng hẹp hơn, nên hồ sơ cần cho thấy con đường mở rộng ra khu vực, không chỉ trong nước."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/viet-nam-2025-72-phan-tram.webp",
          "alt": "Thanh chia vốn VC vào Việt Nam năm 2025: 10 thương vụ lớn nhất 154 triệu USD chiếm 72%, 31 thương vụ còn lại 61 triệu USD chiếm 28%, tổng 215 triệu USD",
          "caption": "",
          "width": 1600,
          "height": 623,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/viet-nam-2025-72-phan-tram-hep.webp"
        }
      },
      {
        "heading": "Năm câu hỏi nhà đầu tư dùng để chấm bạn",
        "paragraphs": [
          "Mỗi khoản đầu tư mang bốn loại rủi ro: làm ra được sản phẩm không, thị trường có cần không, đội ngũ có đưa ra thị trường được không, và có gọi được các vòng sau không. Nhà đầu tư đánh giá bạn đã gỡ được bao nhiêu rủi ro qua 5T.",
          "Hai chữ T founder hay bỏ sót nhất là Technology ([[don-bay-mo-rong|đòn bẩy mở rộng]]) và Trenches ([[hao-phong-thu|hào phòng thủ]]). Từ 01/11/2026, công cụ Điểm sẵn sàng gọi vốn và Kiểm tra pitch deck trên fundraising.vn chấm thêm hai mục này."
        ],
        "table": {
          "caption": "5T và bằng chứng nên có trong hồ sơ",
          "headers": [
            "Chữ T",
            "Nhà đầu tư muốn thấy",
            "Bằng chứng nên có"
          ],
          "rows": [
            [
              "Team: đội ngũ",
              "Gắn kết, đủ năng lực thực thi",
              "Vai trò rõ ràng, kinh nghiệm liên quan, cổ phần sáng lập chia hợp lý"
            ],
            [
              "TAM: quy mô thị trường",
              "Thị trường đủ lớn để có công ty tỷ đô",
              "TAM, SAM, SOM tính từ dưới lên, lộ trình ra khu vực"
            ],
            [
              "Technology: đòn bẩy mở rộng",
              "Lớn nhanh mà chi phí không phình theo",
              "Chi phí phục vụ thêm một khách giảm dần khi quy mô tăng; phần việc nào đã tự động hoá"
            ],
            [
              "Traction: sức kéo",
              "Đã có khách và đang tăng nhanh",
              "Doanh thu, người dùng, tỷ lệ giữ chân theo tháng"
            ],
            [
              "Trenches: hào phòng thủ",
              "Đối thủ khó sao chép",
              "Dữ liệu riêng, hiệu ứng mạng, chi phí chuyển đổi của khách, giấy phép, kênh phân phối độc quyền"
            ]
          ]
        },
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/nam-cau-hoi-5t.webp",
          "alt": "Năm thẻ 5T: Team, TAM, Technology, Traction, Trenches, mỗi thẻ một câu hỏi; Technology (đòn bẩy mở rộng) và Trenches (hào phòng thủ) được đánh dấu hay bị bỏ sót",
          "caption": "",
          "width": 1600,
          "height": 495,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/nam-cau-hoi-5t-hep.webp"
        }
      },
      {
        "heading": "Tự tính mốc trả lại cả quỹ",
        "paragraphs": [
          "Trước khi gặp một quỹ, lấy quy mô quỹ chia cho phần trăm cổ phần quỹ có thể còn giữ lúc thoát vốn. Kết quả là giá thoát vốn tối thiểu để công ty bạn một mình [[cong-ty-tra-lai-ca-quy|trả lại cả quỹ]]."
        ],
        "table": {
          "caption": "Giá thoát vốn cần có để một công ty trả lại cả quỹ",
          "headers": [
            "Quy mô quỹ",
            "Quỹ còn giữ khi thoát vốn",
            "Công ty cần thoát vốn ở mức"
          ],
          "rows": [
            [
              "20 triệu USD",
              "10%",
              "200 triệu USD"
            ],
            [
              "50 triệu USD",
              "10%",
              "500 triệu USD"
            ],
            [
              "100 triệu USD",
              "10%",
              "1 tỷ USD"
            ]
          ]
        },
        "notes": [
          "Đặt con số này cạnh kế hoạch 5 đến 7 năm của bạn. Nếu kế hoạch không có đường hợp lý tới mức đó, quỹ khó nói có, dù công ty tốt."
        ],
        "image": {
          "url": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/moc-tra-lai-ca-quy.webp",
          "alt": "Biểu đồ cột giá công ty cần bán được để trả lại cả quỹ: quỹ 20, 50, 100 triệu USD cần 200, 500, 1.000 triệu nếu quỹ còn giữ 10%, và 100, 250, 500 triệu nếu còn giữ 20%",
          "caption": "",
          "width": 1600,
          "height": 880,
          "fit": "nguyen-ban",
          "position": "cuoi",
          "urlHep": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai/moc-tra-lai-ca-quy-hep.webp"
        }
      },
      {
        "heading": "Founder nên làm gì",
        "bullets": [
          "Tìm hiểu quy mô quỹ và vòng đầu tư của quỹ bạn định tiếp cận, rồi tính mốc trả lại cả quỹ.",
          "Kể câu chuyện ở đúng quy mô đó: slide thị trường và kế hoạch phải có giả định cụ thể về số khách, giá, thị phần, thị trường mở rộng.",
          "Chứng minh đòn bẩy mở rộng bằng số: chi phí phục vụ một khách hôm nay và khi gấp 10 lần quy mô.",
          "Nói được hào phòng thủ trong một câu, kèm bằng chứng, không chỉ ghi \"không có đối thủ\".",
          "Mỗi vòng gọi vốn nên gỡ được ít nhất một trong bốn rủi ro, và nói rõ vòng này gỡ rủi ro nào.",
          "Nếu doanh nghiệp tốt nhưng khó vượt vài chục triệu USD, cân nhắc nhà đầu tư thiên thần, vốn vay, quỹ tăng trưởng nhỏ hoặc tự tài trợ. Không phải vì bạn kém, mà vì phép tính của VC không khớp với bạn."
        ]
      },
      {
        "heading": "Tóm lại",
        "paragraphs": [
          "Quỹ VC phải nhân vốn khoảng 3,1 lần trong 10 năm, trong khi phần lớn khoản đầu tư sẽ lỗ. Vì vậy quỹ chỉ rót tiền vào công ty có khả năng trả lại cả quỹ. Hồ sơ của bạn cần chứng minh khả năng đó qua 5T, nhất là đòn bẩy mở rộng và hào phòng thủ."
        ]
      }
    ],
    "sources": [
      {
        "label": "Seth Levine: The Markets Are Great but Venture Outcomes Haven't Changed Much (dữ liệu Correlation Ventures)",
        "url": "https://sethlevine.com/archives/2019/09/the-markets-are-great-but-venture-outcomes-havent-changed-much.html"
      },
      {
        "label": "LifeSciVC: Correlation's Fresh Look at Venture Capital Returns",
        "url": "https://lifescivc.com/?p=452"
      },
      {
        "label": "Correlation Ventures: Venture Capital, We're Still Not Normal",
        "url": "https://medium.com/correlation-ventures/venture-capital-were-still-not-normal-9d07d354db88"
      },
      {
        "label": "Masterworks Research: What is venture capital and how do VC returns work (dữ liệu Horsley Bridge)",
        "url": "https://www.masterworks.com/academy/posts/what-is-venture-capital-and-how-do-vc-returns-work"
      },
      {
        "label": "VietnamNet: Vietnam's start-up market enters restructuring phase (báo cáo VinVentures 2025)",
        "url": "https://vietnamnet.vn/en/vietnam-s-start-up-market-enters-restructuring-phase-2484098.html"
      },
      {
        "label": "Việt Nam News: Báo cáo Đổi mới sáng tạo và Vốn tư nhân Việt Nam (NIC, VPCA, Do Ventures)",
        "url": "https://vietnamnews.vn/economy/1782451/"
      }
    ],
    "coverImage": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai.webp",
    "ogImage": "https://fundraising.vn/anh/playbook/toan-hoc-quy-vc-vi-sao-quy-tu-choi-startup-co-lai-og.jpg",
    "coverAlt": "Quỹ 100 triệu USD phải trả về 310 triệu USD: chỉ khi có một công ty thoát vốn 1 tỷ USD, quỹ mới vượt mục tiêu",
    "coverCaption": "Lợi nhuận của cả quỹ VC thường dồn vào một hoặc hai công ty.",
    "templates": []
  }
];
